import React from "react";
import { Checkbox, ControlLabel, FormGroup } from "react-bootstrap";
import locale from "../../../../../locale";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import Tooltip from "../../../../UI/Tooltip";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingRadio from "../../../../UI/Settings/CPSettingRadio";
import CPSettingUploadImage from "../../../../UI/Settings/CPSettingUploadImage";
import { ELEMENT_POSITIONING } from "./models";
import { availableTypesBackground } from "../../../EventSettings/models";
import DiffStartTimeout from "../../components/DiffStartTimeout";

const CommonHallsSettings = ({pageSettings, onChangePageSettings, onSaveSettings, isSettingsMobileOpenModule}) => {
    return (
        <>
            <ControlLabel>{locale('settings.title')}</ControlLabel>
            <Checkbox
                checked={pageSettings?.showTitle}
                onChange={(e) => onSaveSettings({showTitle: e.target.checked})}
            >
                {locale('settings.showTitle')}
            </Checkbox>
            {
                pageSettings.showTitle &&
                <FormGroup>
                    <FormGroup>
                        <FormControlLanguage
                            type="text"
                            values={{
                                ru: pageSettings.titleRu,
                                en: pageSettings.titleEn,
                            }}
                            onChange={{
                                ru: (e) => onChangePageSettings({titleRu: e.target.value}),
                                en: (e) => onChangePageSettings({titleEn: e.target.value}),
                            }}
                            onBlur={() => onSaveSettings({...pageSettings, titleRu: pageSettings.titleRu, titleEn: pageSettings.titleEn})}
                        />
                    </FormGroup>
                    <div 
                        style={{display: 'flex', columnGap: '20px'}}
                    >
                        <CPSettingSize
                            name="titleSize"
                            label={locale('settings.titleSize')}
                            eventValue={pageSettings?.titleSize}
                            defaultValue={'24px'}
                            onChange={onSaveSettings}
                        />
                        <Checkbox
                            checked={pageSettings.titleBold}
                            onChange={(e) => onSaveSettings({titleBold: e.target.checked})}
                        >
                            Bold
                        </Checkbox>
                    </div>
                </FormGroup>
            }
            <ControlLabel>{locale('settings.subtitle')}</ControlLabel>
            <Checkbox
                checked={pageSettings.showSubtitle}
                onChange={(e) => onSaveSettings({showSubtitle: e.target.checked})}
            >
                {locale('settings.showSubtitle')}
            </Checkbox>
            {
                pageSettings.showSubtitle &&
                <DiffStartTimeout
                    diffStartTimeout={pageSettings.diffStartTimeout}
                    onSaveSettings={onSaveSettings}
                />
            }
            {
                pageSettings.showSubtitle &&
                <div style={{display: 'flex', columnGap: '20px'}}>
                    <CPSettingSize
                        name="subtitleSize"
                        label={locale('settings.subtitleSize')}
                        eventValue={pageSettings?.subtitleSize}
                        defaultValue={'24px'}
                        onChange={onSaveSettings}
                    />
                    <Checkbox
                        checked={pageSettings.subtitleBold}
                        onChange={(e) => onSaveSettings({subtitleBold: e.target.checked})}
                    >
                        Bold
                    </Checkbox>
                </div>
            }
            <CPSettingRadio
                name="headerAlign"
                eventValue={pageSettings.headerAlign}
                defaultValue="lext"
                label={locale('settings.headingPositioning')}
                options={ELEMENT_POSITIONING(locale)}
                onChange={onSaveSettings}
            />
            <Checkbox
                checked={pageSettings.askQuestionAccentStyle}
                onChange={(e) => onSaveSettings({askQuestionAccentStyle: e.target.checked})}
            >
                {locale('settings.color.accentStyleButton')}
            </Checkbox>
            <hr />
            <ControlLabel>{locale('settings.player')}</ControlLabel>
            <Checkbox
                checked={pageSettings.showPlayer}
                onChange={(e) => onSaveSettings({showPlayer: e.target.checked})}
            >
                {locale('settings.showPlayerOffline')}
            </Checkbox>
            <hr />
            <CPSettingUploadImage
                eventImage={pageSettings.backgroundUrl}
                title={locale('settings.uploadBackgroundImage')}
                settingName="background"
                hasCropper={false}
                availableTypes={availableTypesBackground}
                maxImageHeight="300px"
                onUpdate={onSaveSettings}
            />
            <Checkbox
                checked={pageSettings.backgroundFixed}
                onChange={(e) => onSaveSettings({backgroundFixed: e.target.checked})}
            >
                {locale('settings.backgroundFixed')}
                <Tooltip width="300px">
                    {locale('settings.backgroundFixedTooltip')}
                </Tooltip>
            </Checkbox>
            {isSettingsMobileOpenModule &&
                <>
                    <hr />
                    <Checkbox
                        checked={pageSettings.isMobileOpenModule}
                        onChange={(e) => onSaveSettings({ isMobileOpenModule: e.target.checked })}
                    >
                        {locale('settings.mobileOpenModule')}
                    </Checkbox>
                </>
            }
        </>
    );
};

export default CommonHallsSettings;
